import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const STORAGE_KEY = 'hunter.showSources';

/**
 * Whether the company page shows the source badges ("Show sources"), on by
 * default and kept in localStorage where the browser allows it.
 */
@Injectable({ providedIn: 'root' })
export class SourceDisplayService {
  private readonly visible = new BehaviorSubject<boolean>(this.read());
  public readonly visible$ = this.visible.asObservable();

  get isVisible() {
    return this.visible.value;
  }

  setVisible(visible: boolean) {
    this.visible.next(visible);
    try {
      localStorage.setItem(STORAGE_KEY, visible ? '1' : '0');
    } catch {
      // Storage blocked: the setting lasts for this page only.
    }
  }

  private read(): boolean {
    try {
      return localStorage.getItem(STORAGE_KEY) !== '0';
    } catch {
      return true;
    }
  }
}
